import {
  getRequest,
  getRequestOfExam,
  postRequestByJson,
  postRequestByBlob,
  putRequest,
  postRequest,
  deleteRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { Message } from "element-ui";

function myThen(data) {
  try {
    if (data.result) {
      return Promise.resolve(data.data);
    } else {
      Message.error(data.failMsg);
      return Promise.reject(data.failMsg);
    }
  } catch (e) {
    return Promise.resolve(data);
  }
}

// 论文分组配置
export const getPaperSettingList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/paperSettingPage",
    params
  ).then(myThen);
};
//获取考试list
export const getPaperApplyList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/queryTestList",
    params
  ).then(myThen);
};
//删除 论文分组
export const delPaperSetting = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/delete/delPaperSetting",
    params
  ).then(myThen);
};
//查询 论文分组详情
export const getPaperSettingDetail = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/queryPaperSettingDetail",
    params
  ).then(myThen);
};
//新增/编辑 论文分组
export const editPaperSetting = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/save/editPaperSetting",
    params
  ).then(myThen);
};
//预约时间分页
export const getReservationTimeList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/interviewSettingList",
    params
  ).then(myThen);
};
//预约时间编辑
export const editReservationTime = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/saveOrUpdate/interviewSetting",
    params
  ).then(myThen);
};
//预约时间详情
export const getReservationTimeDetail = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/queryReservationTimeDetail",
    params
  ).then(myThen);
};
//论文审核分页列表
export const getPaperReviewList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/pageReviewRecordList",
    params
  ).then(myThen);
};
//论文审核详情
export const getPaperReviewDetail = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/paperReviewDetail",
    params
  ).then(myThen);
};
//面试管理列表
export const getPaperInterviewList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/interviewSettingPage",
    params
  ).then(myThen);
};
//面试管理列表导入
export const importPaperInterviewList = (params = {}) => {
  return postRequestByBlob(
    "/bpi/paper-setting/v1/excel/importPaperInterviewList",
    params
  ).then(myThen);
};
//面试管理列表导出
export const exportPaperInterviewList = (params = {}) => {
  return postRequestByBlob(
    "/bpi/paper-setting/v1/export/exportPaperInterviewList",
    params
  ).then(myThen);
};
//面试管理详情
export const getPaperInterviewDetail = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/interviewSettingDetail",
    params
  ).then(myThen);
};
//设置及格分数
export const setPassScore = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/save/setPassScore",
    params
  ).then(myThen);
};
//编辑及格分数
export const editPassScore = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/save/updatePassScore",
    params
  ).then(myThen);
};
//获取及格分数分页列表
export const getPassScoreList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/queryPassScorePage",
    params
  ).then(myThen);
};
//我的论文分页列表
export const getMyPaperList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/paperUploadPage",
    params
  ).then(myThen);
};
//单个论文审核
export const reviewOnePaper = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/review/onePaper",
    params
  ).then(myThen);
};
//论文批量审核
export const reviewBatchPaper = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/review/paperBatch",
    params
  ).then(myThen);
};
//论文分组list
export const getPaperGroupList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/paperSettingList",
    params
  ).then(myThen);
};
//上传论文
export const thesisUpload = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/save/paperUpload",
    params
  ).then(myThen);
};
//导入 审核列表
export const paperReviewExcelImport = (params = {}) => {
  return postRequestByBlob(
    "/bpi/paper-setting/v1/excel/excelImport",
    params
  ).then(myThen);
};
//导出 审核列表
export const paperReviewExcelExport = (params = {}) => {
  return postRequestByBlob(
    "/bpi/paper-setting/v1/export/pageReviewRecordList",
    params
  ).then(myThen);
};
//我的论文答辩分页列表
export const getMyInterviewPage = (params = {}) => {
  return postRequestByBlob(
    "/bpi/paper-setting/v1/query/myInterviewPage",
    params
  ).then(myThen);
};
//一键发布
export const oneClickRelease = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/showPaperReviewResult",
    params
  ).then(myThen);
};
//一键发布面试
export const showPaperReviewResult = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/showPaperReviewResult",
    params
  ).then(myThen);
};
//一键均分
export const oneClickSplit = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/oneClickSplit",
    params
  ).then(myThen);
};
//是否已提交论文
export const paperIsExist = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/paperIsExist",
    params
  ).then(myThen);
};
export const batchDownloadThesis = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/batchDownloadPaper",
    params
  ).then(myThen);
};
export const scoreInterview = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/save/interviewScore",
    params
  ).then(myThen);
};
export const downloadAccessory = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/batchDownloadReply",
    params
  ).then(myThen);
};
export const batchDownloadReport = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/batchDownloadReport",
    params
  ).then(myThen);
};

export const showPaperInterviewResult = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/query/showPaperInterviewResult",
    params
  ).then(myThen);
};
export const getOpenQuestionReportList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/queryPaperOpenQuestionReportPage",
    params
  ).then(myThen);
};
export const queryPaperDetailList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/queryPaperDetailList",
    params
  ).then(myThen);
};
export const examQuestionAnalysis = (params = {}) => {
  return postRequest("/base/echarts/examQuestionAnalysis", params).then(myThen);
};
// 评审设置
export const saveReviewSettings = (params = {}) => {
  return postRequestByJson("/bpi/paper-setting/v1/saveReviewSettings", params);
};
// 获取评审设置
export const getReviewSettings = (params = {}) => {
  return postRequestByJson("/bpi/paper-setting/v1/queryReviewSettings", params).then(
    myThen
  );
};
// 获取评审列表
export const getPaperList = (params = {}) => {
  return getRequest("/bpi/paper-setting/v1/paperSelection", params).then(
    myThen
  );
};
// 提交论文评分
export const scoreThesis = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/review/paperBatch",
    params
  ).then(myThen);
};

// 获取已评分论文
export const getScoredThesis = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/paperPageByTeacher",
    params
  ).then(myThen);
};
// 获取论文得分项
export const getScoreItem = (params = {}) => {
  return postRequestByJson("/bpi/paper-setting/v1/getScoreItem", params).then(
    myThen
  );
};
// 保存论文得分项
export const saveScoreItem = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/updateScoreItem",
    params
  ).then(myThen);
};
// 教师分组列表
export const getTeacherGroupList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/pageTeacherGroup",
    params
  ).then(myThen);
};

// 教师分组列表
export const editTeacherGroup = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/editTeacherGroup",
    params
  ).then(myThen);
};
// 删除教师分组
export const deleteTeacherGroup = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/delTeacherGroup",
    params
  ).then(myThen);
};
// 教师列表
export const getTeacherList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/teacherReviewList",
    params
  ).then(myThen);
};
// 论文分组列表
export const getThesisGroupList = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/pageReviewGroup",
    params
  ).then(myThen);
};
// 编辑论文分组
export const editThesisGroup = (params = {}) => {
  return postRequestByJson(
    "/bpi/paper-setting/v1/editReviewGroup",
    params
  ).then(myThen);
};
//论文一键分组
export const v1thesisGrouping = (params = {}) => {
  return postRequestByJson("/bpi/paper-setting/v1/thesisGrouping", params).then(
    myThen
  );
};
